module.exports = __webpack_public_path__ + "img/schema3-1@2x.c5efc56b.png";